import axios from '@/axiosConnection'
export default {
    namespaced: true,
    state: {
        items: [],
        stock: [],
        stockNumber: 0,
        vehicleAutoReappro: []
    },
    getters: {
        getAll: state => {
            return state.items
        },
        getMyVehicleStockAutoReappro: state => {
            return state.vehicleAutoReappro
        },
        getMyVehicleStock: state => {
            return state.stock
        },
        getMyVehicleStockCount: state => {
            return state.stockNumber
        },
        getItem: state => id => state.items.find(item => item.id == id)
    },
    mutations: {
      setMyVehicleStockAutoReappro(state, vehicleStockAutoReappro) {
        if (vehicleStockAutoReappro) {
          state.vehicleAutoReappro = vehicleStockAutoReappro
        }
      },
      setStockNumber(state, stockNb) {
        if (stockNb) {
          state.stockNumber = stockNb
        }
      },
      setStock(state, stock) {
        if (stock) {
          state.stock = stock
        }
      },
      emptyStock(state){
        state.stock = []
        state.stockNumber = 0
      },
    },
    actions: {

        /**
         * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
         * @param   boolean wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
         * @returns promise       Aucune donnée n'est retournée
         */
        getAll: (context, wait = false) => {
            let params = {
                wait: wait,
                api_url: 'vehicle',
                api_data_path: 'vehicles',
                namespace: 'vehicle'
            }
            return context.dispatch('getAll', params, {
                root: true
            })
        },
        getMyVehicleStockAutoReappro: (context, wait = false) => {
          return new Promise(function (resolve, reject) {
            axios.get('vehicle/current/reappro')
              .then(response => {

                context.commit('setMyVehicleStockAutoReappro', response.data);

                resolve()
              })
              .catch(error => {
                reject()
              })
          })
        },
        getMyVehicleStock: (context, wait = false) => {
          return new Promise(function (resolve, reject) {
            if (wait == false && context.state.stockNumber && context.state.stockNumber.length) {
              resolve()
            }
            axios.get('vehicle/current')
              .then(response => {

                if(response.data == 'no-stock'){
                  context.commit('emptyStock');
                }else{
                  context.commit('setStock', response.data);
                }

                resolve()
              })
              .catch(error => {
                // toastr.error("Le chargement de la liste a échoué")
                reject()
              })
          })
        },
        getMyVehicleStockCount: (context, wait = false) => {
          return new Promise(function (resolve, reject) {
            if (wait == false && context.state.stock && context.state.stock.length) {
              resolve()
            }
            axios.get('vehicle/current/stock')
              .then(response => {

                let nbItems = 0;

                if(response.data[0]){
                  for(var j = 0; j < response.data[0].length; j++){
                    if(response.data[0][j].restocking == 1 && response.data[0][j].stock <= response.data[0][j].min_stock){
                      nbItems += 1;
                    }
                  }
                }

                if(nbItems){
                  context.commit('setStockNumber', nbItems);
                }

                resolve()
              })
              .catch(error => {
                // toastr.error("Le chargement de la liste a échoué")
                reject()
              })
          })
        },
        addItem(context, item) {
            let params = {
                api_url: 'vehicle',
                namespace: 'vehicle',
                item: item
            }
            context.dispatch('addItem', params, {
                root: true
            })
        },
        saveItem(context, item) {
            let params = {
                api_url: 'vehicle',
                namespace: 'vehicle',
                item: item
            }
            context.dispatch('saveItem', params, {
                root: true
            })
        },
        deleteItem(context, id) {
            let params = {
                api_url: 'vehicle',
                namespace: 'vehicle',
                id: id
            }
            context.dispatch('deleteItem', params, {
                root: true
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/modules/vehicle.js